import Section from './DTO/Response/Section'

export default class PreviewSection {
  public section: Section
  public component: Promise<any>

  constructor (section: Section, component: Promise<any>) {
    this.section = section
    this.component = component
  }
}
